import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Publicaciones from './pages/Publicaciones';
import NuevaPublicacion from './pages/NuevaPublicacion';
import DetallePublicacion from './pages/DetallePublicacion';
import Ofertas from './pages/Ofertas';
import Compradores from './pages/Compradores';
import Frigorificos from './pages/Frigorificos';
import Productos from './pages/Productos';
import Usuarios from './pages/Usuarios';
import Reportes from './pages/Reportes';
import Mensajes from './pages/Mensajes';
import Auditoria from './pages/Auditoria';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="publicaciones" element={<Publicaciones />} />
                <Route path="publicaciones/nueva" element={<NuevaPublicacion />} />
                <Route path="publicaciones/:id" element={<DetallePublicacion />} />
                <Route path="publicaciones/:id/editar" element={<NuevaPublicacion />} />
                <Route path="ofertas" element={<Ofertas />} />
                <Route path="productos" element={<AdminRoute><Productos /></AdminRoute>} />
                <Route path="compradores" element={<AdminRoute><Compradores /></AdminRoute>} />
                <Route path="frigorificos" element={<AdminRoute><Frigorificos /></AdminRoute>} />
                <Route path="usuarios" element={<AdminRoute><Usuarios /></AdminRoute>} />
                <Route path="mensajes" element={<AdminRoute><Mensajes /></AdminRoute>} />
                <Route path="reportes" element={<AdminRoute><Reportes /></AdminRoute>} />
                <Route path="auditoria" element={<AdminRoute><Auditoria /></AdminRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;